







































































































































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import InCategoryTopMenuComponent from "@/components/layout/InCategoryTopMenuComponent.vue";
import isOverThreshold from "@/typescript/lib/common/is_over_threshold";
import PagenationComponent from "@/components/common/parts/PagenationComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import { WarningHistory } from "@/typescript/pages/warning_histories/types";
import { Moment } from "@/typescript/lib/common/moment";
import { getEquipmentIcon } from "../../../typescript/lib/common/get_equipment_icon";
import { getAlertData } from "../../../typescript/lib/common/get_alert_data";
import { getRoutePath } from "../../../router/routes";
export { WarningHistory };
@Component({
  components: {
    InCategoryTopMenuComponent,
    PagenationComponent,
    EllipsisComponent,
    ButtonComponent
  }
})
export default class WarningHistoriesMainComponent extends Vue {
  $refs!: {
    pagenation: PagenationComponent;
  };

  warningLatests: any[] = [];

  @Prop({
    default: []
  })
  warningHistories!: WarningHistory;

  @Prop()
  currentPageNo!: number;

  PAGE_COUNT: number = 10;

  @Emit()
  changePage(num: number) {
    return num;
  }

  @Emit()
  moveNextPage(isMove: boolean) {
    return isMove;
  }

  @Emit()
  movePrevPage(isMove: boolean) {
    return isMove;
  }

  @Emit()
  downloadCsv(event: any) {
    return event;
  }

  @Emit()
  stopAlert(equipmentId: string, alertId: string) {
    return { equipmentId: equipmentId, alertId: alertId };
  }

  getIcon(iconKind: number): string {
    if (!iconKind) return "";
    return getEquipmentIcon(iconKind, "on");
  }

  isOverThreshold(ctTemp: number, thLow: number, thHigh: number): boolean {
    return isOverThreshold(ctTemp, thLow, thHigh);
  }

  getItemStartNum(): number {
    if (!this.$refs.pagenation) return 0;
    return this.$refs.pagenation.getItemStartNum();
  }

  getItemEndNum(): number {
    if (!this.$refs.pagenation) return 0;
    return this.$refs.pagenation.getItemEndNum();
  }

  getAlertMsg(alertId: string): string {
    return getAlertData(alertId, 2).msg;
  }

  getStartDate(startDate: string): string {
    return new Moment(
      "YYYY/MM/DD HH:mm",
      startDate,
      "YYYYMMDDHHmmssSSS"
    ).getFormatDate();
  }

  moveGraphPage(equipmentId: string, startDate: string, alertId: string) {
    if (!this.isTempGraphMove(alertId)) return;

    this.$router.push({
      path: getRoutePath("TempGraphsPage", {
        store_id: this.$route.params.store_id
      }),
      query: {
        equipment_id: equipmentId,
        start_date: new Moment(
          "YYYYMMDD",
          startDate,
          "YYYY/MM/DD HH:mm"
        ).getFormatDate()
      }
    });
  }

  isTempGraphMove(alertId: string) {
    return "OE00000001" === alertId || "OE00000002" === alertId;
  }

  // 発生時刻が新しい警報履歴を作成
  @Watch("warningHistories")
  createWarningLatests() {
    this.warningLatests = this.warningHistories.data.reduce(
      (result: any, current) => {
        const element = result.find(
          p =>
            p.equipmentId === current.equipmentId &&
            p.alertId === current.alertId
        );
        if (element) {
          if (element.startDate < current.startDate)
            element.startDate = current.startDate;
        } else {
          result.push({
            equipmentId: current.equipmentId,
            alertId: current.alertId,
            startDate: current.startDate,
            isAlertStatus: current.isAlertStatus
          });
        }
        return result;
      },
      []
    );
  }

  isWarningLatest(equipmentId: string, alertId: string, startDate: string) {
    return this.warningLatests.some(function(data) {
      if (
        data.equipmentId === equipmentId &&
        data.alertId === alertId &&
        data.startDate === startDate &&
        data.isAlertStatus
      )
        return true;
    });
  }
}
